import { useTheme } from '@mui/material/styles';

import { getSafeContrastText } from 'reservations/brand/helpers/getContrastText';

const useContrastTextColor = () => {
  const theme = useTheme();
  const backgroundColor = theme.palette.background.default;
  const textColor = getSafeContrastText(theme, backgroundColor);
  return textColor;
};

export default useContrastTextColor;
